var _path, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClarityAvatar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_927)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94258 0.375H20.0574C21.1031 0.375 22.1059 0.790378 22.8452 1.52976C23.5846 2.26913 24 3.27195 24 4.31758V20.4324C24 21.4781 23.5846 22.4809 22.8452 23.2202C22.1059 23.9596 21.1031 24.375 20.0574 24.375H3.94258C2.89695 24.375 1.89413 23.9596 1.15476 23.2202C0.415378 22.4809 0 21.4781 0 20.4324V4.31758C0 3.27195 0.415378 2.26913 1.15476 1.52976C1.89413 0.790378 2.89695 0.375 3.94258 0.375Z",
    fill: "#FF6B53"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_927",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.625,
    width: 16,
    height: 16,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 10.625L15.8333 8.79169L14 7.95835L15.8333 7.12502L16.6666 5.29169L17.5 7.12502L19.3333 7.95835L17.5 8.79169L16.6666 10.625ZM16.6666 19.9584L15.8333 18.125L14 17.2917L15.8333 16.4584L16.6666 14.625L17.5 16.4584L19.3333 17.2917L17.5 18.125L16.6666 19.9584ZM9.99996 17.9584L8.33329 14.2917L4.66663 12.625L8.33329 10.9584L9.99996 7.29169L11.6666 10.9584L15.3333 12.625L11.6666 14.2917L9.99996 17.9584ZM9.99996 14.725L10.6666 13.2917L12.1 12.625L10.6666 11.9584L9.99996 10.525L9.33329 11.9584L7.89996 12.625L9.33329 13.2917L9.99996 14.725Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.25,
    fill: "white",
    transform: "translate(0 0.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityAvatar2);
export default __webpack_public_path__ + "static/media/clarity-avatar-2.aa6894e0598afe49123dd5166dafba0b.svg";
export { ForwardRef as ReactComponent };